var res = [{"key":"2010","value":"95,920"},{"key":"2011","value":"76,680"},{"key":"2012","value":"75,480"},{"key":"2013","value":"78,990"},{"key":"2014/15","value":"77,340"},{"key":"2015/16","value":"68,462*"},{"key":"2016/17","value":"68,638"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/focus-5.csv
// module id = 614
// module chunks = 0